import { Box, Chip, Typography } from "@mui/material";
import theme from "../../utils/theme";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  count?: number;
  children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, count, children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
      }}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: "#1E1E1E" }}>
            {title}
          </Typography>
          {count !== undefined && (
            <Chip
              label={count}
              size="small"
              sx={{
                backgroundColor: theme.palette.brand.secondary,
                color: theme.palette.brand.success,
                fontWeight: 600,
                fontSize: "13px",
                height: 24,
              }}
            />
          )}
        </Box>
        {subtitle && (
          <Typography variant="body2" sx={{ color: "#878787", mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {children && <Box>{children}</Box>}
    </Box>
  );
};

export default PageHeader;
